
import FlytOgRytmePresentation from "../components/FlytOgRytmePresentation"
const FlytOgRytme = ()=>{
    return(
    <FlytOgRytmePresentation/>)
}
export default FlytOgRytme;